<template>
    <div class="modal_bg" @click="fnEvent(false)"></div>
    <div class="modal_layer">
        <div class="modal_title">
            도움말
            <div class="close_btn" @click="fnEvent(false)">
                <img src="@/assets/common/close.png" alt="" />
            </div>
        </div>
        <div class="modal_content_wrap">
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">검색</div>
                    <div class="help_text">키워드, 이미지, 키워드+이미지 검색 페이지</div>
                </div>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">검색관리</div>
                    <div class="help_text">검색한 리스트 원본을 볼 수 있는 페이지</div>
                </div>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">검색관리 > 구분(검색결과)</div>
                    <div class="help_text">검색한 결과물을 볼 수 있는 페이지</div>
                </div>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">검색관리 > 검색결과 > +버튼</div>
                    <div class="help_text">해당 게시물을 관리할 수 있는 모니터링 페이지에 추가 할 수 있는 버튼</div>
                </div>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">모니터링</div>
                    <div class="help_text">+버튼을 누른 리스트가 있는 페이지</div>
                </div>
                <ul class="help_list">
                    <li>해당 페이지에서 유형분류, 게시물의 상태 확인, 메모 등 리스트의 전체적인 정보를 볼 수 있습니다.</li>
                </ul>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">모니터링 > 유형</div>
                    <div class="help_text">성매매인지 아닌지 구분</div>
                </div>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">모니터링 > 세부유형</div>
                    <div class="help_text">광고물이 어떤 유형인지 분류</div>
                </div>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">모니터링 > 모니터링</div>
                    <div class="help_text">게시물이 삭제 되었는지, 계속 유통되고 있는지 확인가능</div>
                </div>
                <ul class="help_list">
                    <li>유통 : 해당 게시물이 현재도 삭제되지 않고 게시물이 있는 상태를 의미</li>
                    <li>모니터링 : 모니터링 페이지에서 삭제요청하기전 상태</li>
                    <li>삭제요청 : 삭제요청을 한 상태를 의미</li>
                    <li>삭제완료 : 해당게시물이 삭제되었음을 의미</li>
                </ul>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">재유포이력</div>
                    <div class="help_text">모니터링에서 주기를 설정 후 검색한 리스트가 모여있는 페이지</div>
                </div>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">연관검색순위</div>
                    <div class="help_text">
                        검색한 키워드(검색어)에서 찾아낸 게시물중에 현재 가장 많이 나오는 연관검색단어를 순위를 보여주는 페이지
                    </div>
                </div>
            </div>
            <div class="modal_content bg">
                <div class="help_title">
                    <div class="help_key">검색현황</div>
                    <div class="help_text">
                        검색한 키워드(검색어)에서 찾아낸 게시물중에 플랫폼 별로 가장 많이 나오는 연관검색단어를 보여주는 페이지
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { onMounted, onUnmounted, reactive } from "@/BaseComponent";

    export default {
        emits: ["close"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                inputBulr: false,
                isNewKeyword: false as boolean,
            });

            onMounted(() => {
                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "auto";
            });

            const fnEvent = (result: boolean) => {
                emit("close", result);
            };

            return { props, fnEvent, state };
        },
    };
</script>
<style scoped>
    /* .modal_content_wrap {
        max-height: 800px;
        overflow-y: scroll;
    } */

    .modal_content {
        min-height: 38px;
        height: 100%;
        padding: 8px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-bottom: 8px;
    }

    .modal_content .help_title {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        gap: 8px;
    }

    .help_key {
        min-width: 49px;
        height: 30px;
        color: white;
        font-size: 16px;
        background-color: #767676;
        border-radius: 4px;
        display: flex;
        text-align: center;
        justify-content: center;
        padding: 0 10px;
        white-space: nowrap;
    }

    .help_text {
        color: #09244b;
        font-size: 16px;
        font-weight: bold;
        white-space: normal;
        line-height: 1.5;
    }

    .help_list {
        color: #767676;
        width: 90%;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-bottom: 5px;
    }

    .help_list li {
        list-style-type: disc;
    }
</style>
